module.exports = __webpack_public_path__ + "static/media/builder_errors.53812f98.png";